/* eslint-disable max-lines */
import { CFTokens } from '../../../../../tokens';
export const BORDER_COLOR = {
    accent: {
        strong: CFTokens.COLOR.TRANSPARENT,
        subtle: CFTokens.COLOR.CHROMATIC_PRIMARY_MID_TONE,
        vivid: CFTokens.COLOR.CHROMATIC_PRIMARY_MID_TONE,
    },
    boost: {
        strong: CFTokens.COLOR.TRANSPARENT,
        subtle: CFTokens.COLOR.BORDER_WARM,
        vivid: CFTokens.COLOR.TRANSPARENT,
    },
};
export const ICON_COLOR = {
    accent: {
        strong: 'text-and-element-accent',
        subtle: 'text-and-element-default',
        vivid: 'text-and-element-emphasis',
    },
    boost: {
        strong: 'text-and-element-boost',
        subtle: 'text-and-element-brand',
        vivid: 'text-and-element-brand',
    },
};
export const ROOT_COLOR = {
    accent: {
        strong: CFTokens.COLOR.BACKGROUND_DEFAULT_DARK,
        subtle: CFTokens.COLOR.BACKGROUND_BRAND_ACCENT,
        vivid: CFTokens.COLOR.BACKGROUND_DEFAULT,
    },
    boost: {
        strong: CFTokens.COLOR.BACKGROUND_BRAND_DARK,
        subtle: CFTokens.COLOR.BACKGROUND_WARM_2,
        vivid: CFTokens.COLOR.BACKGROUND_BOOST,
    },
};
export const TEXT_COLOR = {
    accent: {
        strong: CFTokens.COLOR.TEXT_AND_ELEMENT_ACCENT,
        subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_DEFAULT,
        vivid: CFTokens.COLOR.TEXT_AND_ELEMENT_EMPHASIS,
    },
    boost: {
        strong: CFTokens.COLOR.TEXT_AND_ELEMENT_BOOST,
        subtle: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
        vivid: CFTokens.COLOR.TEXT_AND_ELEMENT_BRAND,
    },
};
